import styled from 'styled-components';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: fit-content;
    align-items: start;

    & svg {
        margin-top: -7px;
        margin-right: -2px;
    }
`;

export { Wrapper };
